// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// RxJS
import { Observable, of } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../_base/crud';

import { Global } from '../../../../shared/global';
// Models
import { DeliveryChallanModel } from '../_models/deliveryChallan.model';
import { mergeMap } from 'rxjs/operators';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';

const API_CUSTOMERS_URL = Global.BASE_DELIVERY_CHALLAN_ENDPOINT;
const API_URL = Global.BASE_DELIVERY_CHALLAN_BY_COMPANYMID;

@Injectable()
export class DeliveryChallanService {
	loggedCompanyMId: number;

	constructor(private http: HttpClient, private httpUtils: HttpUtilsService,
		private sharedService: ShareddataserviceService) { }

	getLoggedCompanyMId() {
		this.sharedService.companydata.subscribe(data => this.loggedCompanyMId = data[0]["CompanyMId"]);
	}

	// CREATE =>  POST: add a new deliveryChallan to the server
	createDeliveryChallan(deliveryChallan: DeliveryChallanModel): Observable<DeliveryChallanModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DeliveryChallanModel>(API_CUSTOMERS_URL, deliveryChallan, { headers: httpHeaders});
	}

	uploadImage(imageFile: File, imageName:any): Observable<any> {
		let formData = new FormData();
		formData.append('ImageFile', imageFile, imageFile.name);
		formData.append('imageName', imageName);

		const httpHeaders = new HttpHeaders();
		httpHeaders.set('Content-Type', 'multipart/form-data');

		const url = "Global.BASE_UPLOAD_CATEGORY_IMAGE_ENDPOINT";
		// Note: Add headers if needed (tokens/bearer)
		return this.http.post<any>(url, formData, { headers: httpHeaders });
	}

	// READ
	getAllDeliveryChallans(): Observable<DeliveryChallanModel[]> {
		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<DeliveryChallanModel[]>(URL);
	}

	getDeliveryChallanById(DCMId: number): Observable<DeliveryChallanModel> {
		return this.http.get<DeliveryChallanModel>(API_CUSTOMERS_URL + `/${DCMId}`);
	}

	// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	// Server should return filtered/sorted result
	findDeliveryChallans(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<QueryResultsModel[]>(URL).pipe(
            mergeMap(res => {
                const result = this.httpUtils.baseFilter(res, queryParams);
				console.log(result);
                return of(result);
            })
        );
	}

	// UPDATE => PUT: update the deliveryChallan on the server
	updateDeliveryChallan(DCMId: number, deliveryChallan: DeliveryChallanModel): Observable<any> {
		const httpHeader = this.httpUtils.getHTTPHeaders();
		return this.http.put(API_CUSTOMERS_URL + DCMId, deliveryChallan, { headers: httpHeader });
	}

	// DELETE => delete the deliveryChallan from the server
	deleteDeliveryChallan(DCMId: number): Observable<DeliveryChallanModel> {
		const url = `${API_CUSTOMERS_URL}${DCMId}`;
		return this.http.delete<DeliveryChallanModel>(url);
	}
}
